import { render, staticRenderFns } from "./payFailed.vue?vue&type=template&id=ebb14ab6&scoped=true&"
import script from "./payFailed.vue?vue&type=script&lang=js&"
export * from "./payFailed.vue?vue&type=script&lang=js&"
import style0 from "./payFailed.vue?vue&type=style&index=0&id=ebb14ab6&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebb14ab6",
  null
  
)

export default component.exports